import React, { Component } from 'react';
import Logger from '../../util/Logger';
import './CommentCard.css';
import TextTruncate from "react-text-truncate";

export default class CommentCard extends Component {

  static defaultProps = {
    truncate: false
  }

  constructor (props) {
    super(props);
    const { comment } = props;
    if (!comment) {
      Logger.assert('Missing comment in CommentCard component');
    }
    this.state = {
      focused: false
    };
    this.handleFocus = this.handleFocus.bind(this);
  }

  handleFocus() {
    this.setState(state => ({
      focused: !state.focused
    }));
  }

  render () {
    const { comment, truncate } = this.props;
    return (
      <div className="comment-card-bubble"
        onClick={this.handleFocus}
      >
        <div className="author">{ comment.creator_info.user ? comment.creator_info.user.display_name : 'Anonymous'}</div>
        <TextTruncate
          id={comment.id ? `content-${comment.id}` : ""}
          containerClassName={`flex-fill card-contents content-text text-wrap ${
            this.state.focused ? "overflow-auto" : "overflow-hidden"
          }`}
          line={this.state.focused || !truncate ? 0 : 2}
          text={comment.description}
        />
      </div>
    );
  }
}
